import css from 'styled-jsx/css';

export const AccordionStyles = css`
  .accordion {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 767px) {
      gap: 4px;
    }
  }

  .accordion--product {
    gap: 0;
  }

  .accordion--filter {
    gap: 8px;

    @media (max-width: 767px) {
      gap: 4px;
    }
  }
`;
